import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Vehicle categories filters
 */
export class VehicleCategoriesFilters extends ApiRequestFilters {
	/**
	 * Types
	 */
	types?: VehicleCategoryTypeEnum[];

	/**
	 * Vehicle group id values
	 */
	vehicleGroups?: number[];
}
